import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  makeStyles,
} from '@material-ui/core';
// import {
//   ArrowUpward as UrgentIcon,
//   Whatshot as HighIcon,
//   LabelImportant as NormalIcon,
//   ArrowDownward as LowIcon,
// } from '@material-ui/icons';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const PRIORITIES = [
  { label: 'Low', value: 'low', icon: ArrowDownwardIcon, color: '#accacd', backgroundColor: '#fff', helperText: 'Finish Anything Else First' },
  { label: 'Normal', value: 'normal', icon: LabelImportantIcon, color: '#aaa', backgroundColor: '#fff', helperText: 'Standard Workorder' },
  { label: 'High', value: 'high', icon: WhatshotIcon, color: '#fd7e14', backgroundColor: '#fff', helperText: 'Finish By End of Day' },
  { label: 'Urgent', value: 'urgent', icon: ArrowUpwardIcon, color: '#dc3545', backgroundColor: '#fff', helperText: 'Finish Up and Then Do This' },
  { label: 'Critical', value: 'critical', icon: WhatshotIcon, color: '#fd7e14', backgroundColor: '#fff', helperText: 'Drop Everything And Do This!' },
];

const useStyles = makeStyles(theme => ({
  priorityButton: {
    textTransform: 'none',
    fontSize: '0.75rem',
    // padding: theme.spacing(1),
    borderRadius: 4,
    // margin: theme.spacing(1),
    // marginTop: -8,
    // height: '56px',
    // maxHeight: 72,
      height: '100%',
      width: '100%',
    // marginLeft: 8,
    // justifyContent: 'flex-start',
    // border: `1px solid ${theme.palette.grey[400]}`,
  },
  priorityText: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: '1rem',
  },
}));

export default function PriorityPicker({ workorder, updateParent }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  console.log('Priority picker', workorder)
  const currentPriority = PRIORITIES.find(
    p => p.value === workorder.priority
  ) || PRIORITIES[1]; // Default to 'Normal'

  const handleSelect = (priority) => {
    updateParent(priority.label);
    setOpen(false);
  };
  console.log('currentPriority', currentPriority)
  const Icon = currentPriority.icon;
  return (
    <>
      <Button
        className={classes.priorityButton}
        style={{ borderColor: currentPriority.color, backgroundColor: currentPriority.backgroundColor }}
        onClick={() => setOpen(true)}
        variant="outlined"
        size="small"
      >
        <Icon className={classes.icon} style={{ color: currentPriority.color }} />
        <Typography variant="body2" className={classes.priorityText} style={{ color: currentPriority.color }}>
          Priority: {currentPriority.label}
        </Typography>
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Select Priority</DialogTitle>
        <DialogContent dividers>
          <List>
            {PRIORITIES.map(priority => {
               
              return (
              <ListItem
                button
                key={priority.label}
                selected={priority.label === currentPriority.label}
                onClick={() => handleSelect(priority)}
              >
                <ListItemIcon style={{ color: priority.color }}>
                      <Icon />
                </ListItemIcon>
                <ListItemText primary={priority.label} />
              </ListItem>
            )})}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

